import { Link } from "react-router-dom";
import { formatPrice } from "../data/currency";

function GameCard({ game }) {
  const cat = game.category;
  const avgRating = game.reviews_avg_rating
    ? Number(game.reviews_avg_rating).toFixed(1)
    : "—";
  const thumbnail = game.thumbnail_path
    ? `https://api.bongogames.online/storage/${game.thumbnail_path}`
    : "https://placehold.co/300x200/132347/d4af37?text=BongoGames";

  return (
    <div className="game-card">
      <img src={thumbnail} alt={game.title} className="game-card-image" />
      <div className="game-card-body">
        <h3 className="game-card-title">{game.title}</h3>
        <span className="game-card-genre">{cat ? cat.name : ""}</span>
        <div className="game-card-footer">
          <span className="game-card-rating">★ {avgRating}</span>
          <span className="game-card-price">{formatPrice(game.price)}</span>
        </div>
        <Link to={`/game/${game.id}`} className="game-card-btn">View Details</Link>
      </div>
    </div>
  );
}

export default GameCard;
